export default {
    namespaced: true,
    state: {
        from: 'PEGASO',
        category: 'CDL',
        logo: null,
        provider: 'website',
        course_code: '00GIURI',
        website: 'Università Telematica Pegaso',
        token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImE3YTNjN2JhODdkNGYzMDZlNjkwZGNmZmJhYzM3NTE1N2I1YmFlNmVhMzlmMmFjMjE5ZmQ3N2RkZmJmMjA4MjQwZjA0MTVmM2YwZTMzMGQ3In0.eyJhdWQiOiI1IiwianRpIjoiYTdhM2M3YmE4N2Q0ZjMwNmU2OTBkY2ZmYmFjMzc1MTU3YjViYWU2ZWEzOWYyYWMyMTlmZDc3ZGRmYmYyMDgyNDBmMDQxNWYzZjBlMzMwZDciLCJpYXQiOjE2MDE0NzQ3NjcsIm5iZiI6MTYwMTQ3NDc2NywiZXhwIjoyMjMyNjI2NzY3LCJzdWIiOiIyIiwic2NvcGVzIjpbIioiXX0.l89Fxvc0YAphKCAhnzO76PWpbMIuzAQPCEthXkQ61Y0fvdt5HjzhH0JpanuD2SxzAXTDgcwAT9y0Mdmff_slkckMPf5svWBMbkEQOetHMSOwZP5E-9kCyXboBrvza8vPSb0dvGQnv5O-bJMtuzG0WMHTtNS0Ye93MQB1D1YGfYzlOPtH4-xDwpumkb3jmuQuXTVXJlw7T0Jr75-8ZkJd1QV3MxrmrM0UkT9CAZKOOcUyeB53Y54tk9FtbtoHLBMXs7Pcf-bU6CV6cWeNpiDSq5bI-_EyhkoFonvanj9Bsy3rwyqS0GEiPAIWiMpGm0lHFLoe1SYoOOrbQ6gu1VozLJcy6QaAdGzTEDLoWzklkWWVWfi3fVwvkGh8YA-v1af5MajAYJsWB0VBDgkoYHc_0WPYUBvpKINYnhsTA3GwChQOO6grW6gevSgcqX79qxudbj2uYyBUqcdeG4NmikpZcbu0hKCzn5rmKMsFeFSugjns5Zx0fnoBOwAhRsvnbuFb0i3raXiaHKdHq3e0vZ8r-IIbMwDwOaTGRQp_Kz_bjW0u9swSw7I6ih0YDxbljk-0PN5gnPCahbtvvGuKwaTDlgkndS9ayokrT2mCg2rsbnW7VB467Kswbog7bzogegXMOYJdAHBYfVcjmqpCXebMRblpTFEiWpwXAdB7Z1eZdIE',
        show_ecp: true,
        ecp: null,
        ecp_code: null,
        convention: null,
        program: null,
        label: true,
        crm: true,
        tracking: false,
        gads_conversion: false,
        floodlight_conversion: false,
        criteo_conversion: false,
        site_url: 'https://www.unipegaso.it',
        aa: '2022/2023',
        cookieconsent: false,
        cookieconsent_revision: 0,
        first_name: false,
        last_name: false,
        fiscal_code: false,
        campaign: false,
        assicurazione: false,
        user_id: 0,
        show_logo: null,
        lang: 'it'
    },
    mutations: {
        'SET_FROM'(state, from) {
            state.from = from
        },
        'SET_CATEGORY'(state, category) {
            state.category = category
        },
        'SET_LOGO'(state, logo) {
            state.logo = logo
        },
        'SET_PROVIDER'(state, provider) {
            state.provider = provider
        },
        'SET_COURSE_CODE'(state, course_code) {
            state.course_code = course_code
        },
        'SET_WEBSITE'(state, website) {
            state.website = website
        },
        'SET_SHOW_ECP'(state, show_ecp) {
            state.show_ecp = show_ecp
        },
        'SET_ECP'(state, ecp) {
            state.ecp = Number(ecp)
        },
        'SET_ECP_CODE' (state, ecp_code) {
            state.ecp_code = ecp_code
        },
        'SET_CONVENTION'(state, convention) {
            state.convention = Number(convention)
        },
        'SET_PROGRAM'(state, program) {
            state.program = Number(program)
        },
        'SET_LABEL'(state, label) {
            state.label = (label == 'true')
        },
        'SET_TRACKING'(state, tracking) {
            state.tracking = (tracking == 'true')
        },
        'SET_GADS_CONVERSION'(state, gads_conversion) {
            state.gads_conversion = gads_conversion
        },
        'SET_FLOODLIGHT_CONVERSION'(state, floodlight_conversion) {
            state.floodlight_conversion = floodlight_conversion
        },
        'SET_CRITEO_CONVERSION'(state, criteo_conversion) {
            state.criteo_conversion = criteo_conversion
        },
        'SET_SITE_URL'(state, site_url) {
            state.site_url = site_url
        },
        'SET_CRM'(state, crm) {
            state.crm = (crm == 'true')
        },
        'SET_AA'(state, aa) {
            state.aa = aa
        },
        'SET_COOKIECONSENT'(state, cookieconsent) {
            state.cookieconsent = (cookieconsent == 'true')
        },
        'SET_COOKIECONSENT_REVISION'(state, revision) {
            state.cookieconsent_revision = Number(revision)
        },
        'SET_FIRST_NAME'(state, first_name) {
            state.first_name = first_name
        },
        'SET_LAST_NAME'(state, last_name) {
            state.last_name = last_name
        },
        'SET_FISCAL_CODE'(state, fiscal_code) {
            state.fiscal_code = fiscal_code
        },
        'SET_CAMPAIGN'(state, campaign) {
            state.campaign = campaign
        },
        'SET_INSURANCE'(state, val) {
            state.assicurazione = val === 'true';
        },
        'SET_USER'(state, user_id) {
            state.user_id = user_id;
        },
        'SET_SHOW_LOGO' (state, show_logo) {
            state.show_logo = show_logo;
        },
        'SET_LANG' (state, lang) {
            state.lang = lang
        }
    },
    actions: {
        setEcp ({ commit }, ecp_id) {
            commit("SET_ECP", ecp_id);
        },
        loadFromDataset({ commit }, dataset) {
            commit('SET_FROM', dataset.from)
            commit('SET_CATEGORY', dataset.category)
            commit('SET_LOGO', dataset.logo)
            commit('SET_PROVIDER', dataset.provider)
            commit('SET_COURSE_CODE', dataset.courseCode)
            commit('SET_WEBSITE', dataset.website)
            commit('SET_SITE_URL', dataset.siteUrl)
            if (dataset.showEcp) commit('SET_SHOW_ECP', dataset.showEcp)
            if (dataset.ecp) commit('SET_ECP', dataset.ecp)
            if (dataset.convention) commit('SET_CONVENTION', dataset.convention)
            if (dataset.program) commit('SET_PROGRAM', dataset.program)
            if (dataset.label) commit('SET_LABEL', dataset.label)
            if (dataset.tracking) commit('SET_TRACKING', dataset.tracking)
            if (dataset.gadsConversion) commit('SET_GADS_CONVERSION', dataset.gadsConversion)
            if (dataset.floodlightConversion) commit('SET_FLOODLIGHT_CONVERSION', dataset.floodlightConversion)
            if (dataset.criteoConversion) commit('SET_CRITEO_CONVERSION', dataset.criteoConversion)
            if (dataset.crm) commit('SET_CRM', dataset.crm)
            if (dataset.aa) commit('SET_AA', dataset.aa)
            if (dataset.cookieconsent) commit('SET_COOKIECONSENT', dataset.cookieconsent)
            if (dataset.cookieconsentRevision) commit('SET_COOKIECONSENT_REVISION', dataset.cookieconsentRevision)
            if (dataset.firstName) commit('SET_FIRST_NAME', dataset.firstName)
            if (dataset.lastName) commit('SET_LAST_NAME', dataset.lastName)
            if (dataset.fiscalCode) commit('SET_FISCAL_CODE', dataset.fiscalCode)
            if (dataset.campaign) commit('SET_CAMPAIGN', dataset.campaign)
            if (dataset.assicurazione) commit("SET_INSURANCE", dataset.assicurazione);
            if (dataset.user_id) commit("SET_USER", dataset.user_id);
            if (dataset.ecp_code) commit("SET_ECP_CODE", dataset.ecp_code);
            if (dataset.lang) commit('SET_LANG', dataset.lang)
        },
        loadFromUrl({ commit }, params){
            if (params.get('from')) commit('SET_FROM', params.get('from').toUpperCase())
            if (params.get('type')) commit('SET_CATEGORY', params.get('type').toUpperCase())
            if (params.get('logo')) commit('SET_SHOW_LOGO', params.get('logo'))
            if (params.get('ecp')) commit('SET_ECP', params.get('ecp'))
            if (params.get('assicurazione')) commit('SET_INSURANCE', params.get('assicurazione'))
            if (params.get('campaign')) commit('SET_CAMPAIGN', params.get('campaign'))
            if (params.get('user_id')) commit('SET_USER', params.get('user_id'))
            if (params.get('ecp_code')) commit('SET_ECP_CODE', params.get('ecp_code'))
            if (params.get('lang')) commit('SET_LANG', params.get('lang'))
        }
    },
    getters: {
        from: (state) => {
            switch (state.from) {
                case 'PEGASO':
                    return {
                        name: 'Università Telematica Pegaso',
                        ecpPlatformUrl: 'https://orienta.pegaso.multiversity.click',
                        api: 'pegaso',
                        direzionale_id: 5,
                        ecp: 'ecp',
                        ecp_text: 'ECP',
                        crm: 'PEGASO',
                        support: 'supporto@unipegaso.it',
                        contratto: 'https://docs.unipegaso.it/documenti-ufficiali/contratto-con-lo-studente-22-23.pdf'
                    }
                case 'MERCATORUM':
                    return {
                        name: 'Universitas Mercatorum',
                        ecpPlatformUrl: 'https://orienta.mercatorum.multiversity.click',
                        api: 'mercatorum',
                        direzionale_id: 4,
                        ecp: 'ei-point',
                        ecp_text: 'Ei-Point',
                        crm: 'MERCATORUM',
                        support: 'supporto@unimercatorum.it',
                        contratto: 'https://docs.unimercatorum.it/documenti-ufficiali/contratto-con-lo-studente-22-23.pdf'
                    }
                case 'SANRAFFAELE':
                    return {
                        name: 'Università Telematica San Raffaele',
                        ecpPlatformUrl: 'https://orienta.utsr.multiversity.click',
                        api: 'utsr',
                        direzionale_id: 4,
                        ecp: 'ecp',
                        ecp_text: 'ECP',
                        crm: 'SANRAFFAELE',
                        support: 'supporto@uniroma5.it',
                        contratto: 'https://docs.unipegaso.it/documenti-ufficiali/contratto-con-lo-studente-22-23.pdf'
                    }
                case 'SOLE24ORE':
                    return {
                        name: 'Il Sole 24 Ore Formazione',
                        ecpPlatformUrl: 'https://orienta.s24o.multiversity.click',
                        api: 'ilsole24oreformazione',
                        direzionale_id: 4,
                        ecp: 'ecp',
                        ecp_text: 'ECP',
                        crm: 'SOLE24ORE',
                        support: 'supporto@sole24oreformazione.it',
                        contratto: 'https://docs.unipegaso.it/documenti-ufficiali/contratto-con-lo-studente-22-23.pdf'
                    }
                case 'INTERNATIONAL':
                    return {
                        name: 'MED.E.A.',
                        ecpPlatformUrl: 'https://orienta.international.multiversity.click',
                        api: 'international',
                        direzionale_id: 4,
                        ecp: 'ecp',
                        ecp_text: 'ECP',
                        crm: 'PEGASOINTERNATIONAL',
                        support: 'supporto@pegasointernational.eu',
                        contratto: 'https://docs.international.it/documenti-ufficiali/contratto-con-lo-studente-22-23.pdf'
                    }
            }
        },
        category: state => state.category,
        logo: state => state.logo,
        provider: state => state.provider,
        course_code: state => state.course_code,
        website: state => state.website,
        token: state => state.token,
        show_ecp: state => state.show_ecp,
        ecp: state => state.ecp,
        convention: state => state.convention,
        program: state => state.program,
        label: state => state.label,
        tracking: state => state.tracking,
        gads_conversion: state => state.gads_conversion,
        floodlight_conversion: state => state.floodlight_conversion,
        criteo_conversion: state => state.criteo_conversion,
        site_url: state => state.site_url,
        crm: state => state.crm,
        aa: state => state.aa,
        cookieconsent: state => state.cookieconsent,
        cookieconsent_revision: state => state.cookieconsent_revision,
        first_name: state => state.first_name,
        last_name: state => state.last_name,
        fiscal_code: state => state.fiscal_code,
        campaign: state => state.campaign,
        assicurazione: state => state.assicurazione,
        user_id: state => state.user_id,
        show_logo: state => state.show_logo,
        ecp_code: state => state.ecp_code,
        lang: state => state.lang
    }
}
